<div class="resultArea" *ngIf="listData.dataSource.data.length > 0">
  <table mat-table [dataSource]="listData.dataSource" matSort (matSortChange)="sortData($event)" matSortDisableClear>
    <ng-container *ngFor="let col of tableColumns;" matColumnDef={{col.columnDef}}>
      <ng-container *ngIf="col.sortable">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ col.header }}</th>
      </ng-container>
      <ng-container *ngIf="!col.sortable">
        <th mat-header-cell *matHeaderCellDef> {{ col.header }}</th>
      </ng-container>
      <td mat-cell *matCellDef="let row; let last = last">
        {{ col.cell(row) }}
      </td>
    </ng-container>
    <ng-container matColumnDef="expand">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let row;">
        <button mat-icon-button type="button" (click)="toggleExpanded(row)">
          <mat-icon>{{ row.isExpanded ? 'expand_less' : 'expand_more' }}</mat-icon>
        </button>
      </td>
    </ng-container>
    <ng-container matColumnDef="aktionen">
      <th mat-header-cell *matHeaderCellDef>Aktionen</th>
      <td mat-cell *matCellDef="let row;">
        <button appThrottleEvent mat-icon-button type="button" (throttleEvent)="openInPezi(row.data)"
                matTooltip="Im NV Cockpit öffnen"
                matTooltipClass="tooltip-multiline">
          <mat-icon>developer_board</mat-icon>
        </button>
        @if (userService.isAuthorized$('O30_RESET_TO_OFFERT') | async) {
          <button mat-icon-button type="button" (click)="resetToOffertStageOne(row.data)"
                  matTooltip="Auf Offert zurücksetzen"
                  matTooltipClass="tooltip-multiline"
                  [disabled]="isStornoBeantragt(row.data)">
            <mat-icon>subdirectory_arrow_left</mat-icon>
          </button>
        }
        @if (userService.isAuthorized$('O30_EDIT_EMPFEHLUNG') | async) {
          <button mat-icon-button type="button" (click)="beratungChange(row.data)"
                  [matTooltip]="(userTextService.getOffertStage2Bezeichnung$() | async) + ' bearbeiten'"
                  matTooltipClass="tooltip-multiline">
            <mat-icon>build</mat-icon>
          </button>
        }
        @if (userService.isAuthorized$('O30_ERINNERUNG') | async) {
          <app-reminder [polizzeId]="row.data.id" [(reminder)]="row.data.reminder"></app-reminder>
        }
      </td>
    </ng-container>
    <ng-container matColumnDef="erstellen">
      <th mat-header-cell *matHeaderCellDef>Antrag erstellen</th>
      <td mat-cell *matCellDef="let row;">
        <button mat-icon-button type="button" color="accent" [disabled]="!antragSpeichernAllowed(row.data)"
                (click)="createAntrag(row.data)">
          <mat-icon>keyboard_arrow_right</mat-icon>
        </button>
      </td>
    </ng-container>
    <ng-container matColumnDef='expandedColumn'>
      <td mat-cell *matCellDef="let row;" [attr.colspan]="'100%'">
        <div class="ex-container">
          <div class="ex-element">
            <span class="ex-desc bold-text">Betreuernummer</span>
            {{ row.data.betreuernummer ? row.data.betreuernummer : '-' }}
          </div>
          <div class="ex-element">
            <span class="ex-desc bold-text ">Polizzenadresse</span>
            {{ row.data.adresse ? (row.data.adresse | formatAdress) : '-' }}
          </div>
          <div class="ex-element">
            <span class="ex-desc bold-text ">Inkassoadresse</span>
            {{ row.data.inkassoAdresse ? (row.data.inkassoAdresse | formatAdress) : '-' }}
          </div>
          <div class="ex-element">
            <span class="ex-desc bold-text ">Ablaufdatum</span>
            {{ row.data.ablaufdatum ? (row.data.ablaufdatum | formatDate) : '-' }}
          </div>
          <div class="ex-element">
            <span class="ex-desc  bold-text">Zuletzt bearbeitet von:</span>
            {{ row.data.bearbeitet.email }}
          </div>
          <div class="ex-element" *ngIf="row.data.kfzkennzeichen">
            <span class="ex-desc  bold-text">Kennzeichen (KFZ)</span>
            {{ row.data.kfzkennzeichen }}
          </div>
          <div class="ex-element" *ngIf="row.data.kaskoVariante">
            <span class="ex-desc  bold-text">Kaskovariante</span>
            {{ row.data.kaskoVariante }}
          </div>
          <div class="ex-element" *ngIf="row.data.selbstbehalt">
            <span class="ex-desc  bold-text">Selbstbehalt</span>
            {{ row.data.selbstbehalt }}
          </div>
        </div>
      </td>
    </ng-container>
    <ng-container matColumnDef="descriptions">
      <td mat-cell *matCellDef="let row;" [attr.colspan]="'100%'">
        <div class="desc-box">
          <div class="add-row">
            <span class="fixed-col gray-text">Informationsblätter</span>
            <span class="fixed-col">
                <div class="icon-text">
                  <span class="check-msg">{{ getStatusText(row.data.ipidkid) }}</span>
                  <mat-icon
                    [ngClass]="[getStatusIconClass(row.data.ipidkid)]">{{ getStatusIcon(row.data.ipidkid) }}</mat-icon>
                </div>
              </span>
            <div class="flex-container" *ngIf="bearbeitenErlaubt">
              <div class="button-col">
                <button mat-raised-button class="mat-gray-bg button-right-margin flex-button"
                        (click)="sendIPIDKID(row.data)">
                  SENDEN
                </button>
                <button mat-raised-button class="mat-gray-bg flex-button" (click)="openIPIDKID(row.data)">
                  PAPIER
                </button>
              </div>
              <mat-icon class="info-icon"
                        matTooltip="Die Produkt-/Basisinformationsblätter (IPID/KID) sind dem Kunden rechtzeitig vor Antragsunterfertigung zur Verfügung zu stellen, damit dieser in der Lage ist, wohlinformiert seine Entscheidung treffen zu können. Sorgen Sie daher dafür, dass vor Antragsunterfertigung genügend Zeit für das Durchlesen und Stellen allfälliger Fragen vorhanden ist."
                        matTooltipPosition="right"
                        matTooltipClass="tooltip-multiline">info_outline
              </mat-icon>
            </div>
          </div>
          <div class="add-row">
            <span class="fixed-col gray-text">Risikoanalyse</span>
            <span class="fixed-col"><div class="icon-text">
                  <span class="check-msg">{{ getStatusText(row.data.risikoanalyse) }}</span>
                  <mat-icon
                    [ngClass]="[getStatusIconClass(row.data.risikoanalyse)]">{{ getStatusIcon(row.data.risikoanalyse) }}</mat-icon>
                </div>
            </span>
            <div class="flex-container" *ngIf="bearbeitenErlaubt">
              <div class="button-col">
                <button mat-raised-button class="mat-gray-bg flex-button" (click)="gotoRisikoanalyse(row.data)">
                  DURCHFÜHREN
                </button>
              </div>
              <mat-icon class="info-icon"
                        matTooltip="Mit der Risikoanalyse wird gemeinsam mit dem Kunden erhoben, ob der Kunde die Risiken der angeführten Risikokreise – und zwar unabhängig ob bei der NV oder beim Mitbewerb – entsprechend abgedeckt, teilweise abgedeckt oder nicht abgedeckt hat. In weiterer Folge kann der Kunde angeben, ob er Interesse an einem Beratungsgespräch zu einem Risikokreis, der nicht oder nur teilweise abgedeckt ist, hat und ob er dieses Beratungsgespräch jetzt oder zu einem späteren Zeitpunkt führen möchte. In letzterem Fall wird mit dem Kunden vereinbart, ab wann hierzu eine Kontaktaufnahme erfolgen soll.
Der Zeitpunkt der vereinbarten Kontaktaufnahme inkl. der gemeinsam festgelegten Risikokreise werden im Beratungsprotokoll angedruckt. Weiters sind diese Kontaktaufnahmen im Vertriebscockpit ersichtlich.
Die Risikoanalyse ist 12 Monate gültig, kann jedoch jederzeit aktualisiert werden."
                        matTooltipPosition="right"
                        matTooltipClass="tooltip-multiline">info_outline
              </mat-icon>
            </div>
          </div>
          <ng-container *ngIf="row.data.elektronischeKommunikation">
            <ng-container
              *ngTemplateOutlet="elektronischeko, context: {row: row, title: 'Elektronische Kommunikation (VN)', forwhom: 'forKunde'}">
            </ng-container>
          </ng-container>
          @if (userService.isAuthorized$('O30_ELEK_BTZ') | async) {
            <ng-container
              *ngIf="row.data.abweichenderBeitragszahler && row.data.elektronischeKommunikationBeitragszahler">
              <ng-container
                *ngTemplateOutlet="elektronischeko, context: {row: row, title: 'Elektronische Kommunikation (BZ)', forwhom: 'forBeitragszahler'}">
              </ng-container>
            </ng-container>
          }
          <div class="add-row">
            <span class="fixed-col gray-text">Kundenportal</span>
            <span class="fixed-col">
              <div class="icon-text">
                  <span class="check-msg">{{ getKundenPortalStatusText(row.data) }}</span>
                  <mat-icon
                    [ngClass]="[getKundenPortalStatusIconClass(row.data)]">{{ getKundenPortalStatusIcon(row.data) }}</mat-icon>
              </div>
            </span>
            <div class="flex-container" *ngIf="bearbeitenErlaubt">
              <div class="button-col">
                <button mat-raised-button class="mat-gray-bg flex-button" (click)="openKundenPortalDialog(row.data)"
                        [disabled]="isKundenportalDisabled(row.data)">
                  INFORMIEREN
                </button>
              </div>
            </div>
          </div>
          <div class="add-row" *ngIf="row.data.offenlegungAnswerNeeded">
            <span class="fixed-col gray-text">Offenlegung</span>
            <span class="fixed-col">
              <div class="icon-text">
                  <span class="check-msg">{{ getOffenlegungspflichtText(row.data) }}</span>
                  <mat-icon
                    [ngClass]="[getOffenlegungspflichtIconClass(row.data)]">{{ getOffenlegungspflichtIcon(row.data) }}</mat-icon>
              </div>
            </span>
            <div class="flex-container" *ngIf="bearbeitenErlaubt">
              <div class="button-col">
                <button mat-raised-button class="mat-gray-bg flex-button" (click)="acceptOffenlegungspflicht(row.data)">
                  Informiert und zugestimmt
                </button>
              </div>
              <mat-icon class="info-icon"
                        matTooltip="Der Kunde stimmt zu, dass ihm die Auskünfte zu den nachhaltigkeitsbezogenen Offenlegungen gemäß der Verordnungen (EU) 2019/2088 und 2020/852 über unser Kundenportal www.meine.nv.at zur Verfügung gestellt werden."
                        matTooltipPosition="right"
                        matTooltipClass="tooltip-multiline">info_outline
              </mat-icon>
            </div>
          </div>
          <div class="add-row">
            <span class="fixed-col gray-text">Kontaktdaten</span>
            <span class="fixed-col">
              <div class="icon-text">
                  <span class="check-msg">{{ getKontaktdatenStatus(row.data.id).text }}</span>
                  <mat-icon
                    [ngClass]="[getKontaktdatenStatus(row.data.id).iconClass]">{{ getKontaktdatenStatus(row.data.id).icon }}</mat-icon>
              </div>
            </span>
            <div class="flex-container" *ngIf="bearbeitenErlaubt">
              <div class="button-col">
                <button *ngIf="isKontaktdatenMissing(row.data.id)" mat-raised-button
                        class="mat-gray-bg flex-button button-right-margin"
                        (click)="kontaktdatenErfassen(row.data.personId, row.data.id)">
                  ERFASSEN
                </button>
                <button *ngIf="isKontaktdatenMissing(row.data.id)" mat-raised-button class="mat-gray-bg flex-button"
                        (click)="kontaktdatenKeineBekanntgabe(row.data.id)">
                  KEINE BEKANNTGABE
                </button>
                <button *ngIf="!isKontaktdatenMissing(row.data.id)" mat-raised-button class="mat-gray-bg flex-button"
                        (click)="kontaktdatenPruefen(row.data.personId, row.data.id)">
                  PRÜFEN
                </button>
              </div> <!-- TODO review text in makler context -->
              <mat-icon class="info-icon"
                        matTooltip="Kontaktdaten im Status Beratung/Empfehlung
Wenn keine Kontaktdaten vorhanden sind (E-Mail-Adressen und Mobilnummer sind nicht vorhanden):

Ist der Status ,,nicht vorhanden“ und ein rotes ,,X“.

Wenn Sie auf den Button ,,Erfassen“ klicken, öffnet sich die Kundenstammdaten-Maske, wo sie die Kontaktdaten zum Kunden erfassen können.
Wenn der Kunde keine Kontaktdaten bekannt geben möchte, gibt es die Möglichkeit ,,Keine Bekanntgabe“ zu klicken.
Wenn die Kontaktdaten vorhanden', die Erfassung jedoch mehr als 6 Monate zurückliegt und die Prüfung der Kontaktdaten noch nicht durchgeführt wurde:

Ist der Status ,,nicht geprüft“ und ein grünes ,,X“.

Klicken Sie hier auf den Button ,,Prüfen“, um die Kontaktdaten des Kunden zu überprüfen und ggf. richtig zu stellen.
Nach der Prüfung ändert sich der Status auf ,,aktuell“ und das grüne ,,X“ wird ein grünes ,,Hakerl“.
Wenn die Kontaktdaten vorhanden' und die Prüfung durchgeführt wurde:

Ist der Status ,,aktuell“ und es wird ein grünes Hakerl angezeigt.

'Kontaktdaten vorhanden = Mobilnummer oder E-Mail-Adresse vorhanden."
                        matTooltipPosition="right"
                        matTooltipClass="tooltip-multiline">info_outline
              </mat-icon>
            </div>
          </div>
          <div class="add-row">
            <span class="fixed-col gray-text">Beratungsprotokoll</span>
            <span class="fixed-col">
              <div class="icon-text">
                  <span class="check-msg">{{ getStatusText(row.data.beratungsprotokoll) }}</span>
                  <mat-icon
                    [ngClass]="[getStatusIconClass(row.data.beratungsprotokoll)]">{{ getStatusIcon(row.data.beratungsprotokoll) }}</mat-icon>
              </div>
            </span>
            <div class="flex-container" *ngIf="bearbeitenErlaubt">
              <div class="button-col">
                <button mat-raised-button class="mat-gray-bg button-right-margin flex-button"
                        (click)="sendBeratungsprotokoll(row.data)" [disabled]="!beratungsProtokollAllowed(row.data)">
                  SENDEN
                </button>
                <button mat-raised-button class="mat-gray-bg flex-button" (click)="openBeratungsprotokoll(row.data)"
                        [disabled]="generatingBeratungsProtokoll === row.data.id || !beratungsProtokollAllowed(row.data)">
                  <ng-container *ngIf="generatingBeratungsProtokoll === row.data.id">
                    <mat-spinner [diameter]="20" [strokeWidth]="3"></mat-spinner>
                  </ng-container>
                  <ng-container *ngIf="generatingBeratungsProtokoll !== row.data.id">
                    PAPIER
                  </ng-container>
                </button>
              </div>
              <mat-icon class="info-icon"
                        matTooltip="Um einen Antrag zu erstellen, müssen Sie das Beratungsprotokoll ausgehändigt haben. Dies ist nur möglich, wenn Sie die Produkt-/ Basisinformationsblätter (IPID/KID) und die Datenschutzinformation ausgehändigt haben."
                        matTooltipPosition="right"
                        matTooltipClass="tooltip-multiline">info_outline
              </mat-icon>
            </div>
          </div>
        </div>
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="border-row"
        [ngClass]="{'expanded': row.isExpanded, 'marked': row.data.id === (markedPolintSubject | async), 'offertstagetwo-row': true}"></tr>
    <tr mat-row *matRowDef="let row; columns: ['expandedColumn']; when: isExpansionDetailRow"
        [@detailExpand]="row.isExpanded ? 'expanded' : 'collapsed'"
        class="offertstagetwo-row"></tr>
    <tr mat-row *matRowDef="let row; columns: ['descriptions']; when: isNonExpandableDetailRow"
        class="border-row, offertstagetwo-row"></tr>
  </table>
</div>
<div [ngClass]="listData.dataSource.filteredData.length>30 ? 'custom-pagination' : 'displaynone'">
  <div class="pagination-text">{{ currentPaginationLabel }}</div>
  <mat-paginator class="custom-paginator" (page)="updateLabel()" [hidePageSize]="true" [pageSizeOptions]="[30]"
                 [length]="listData.dataSource.filteredData.length"></mat-paginator>
</div>
<div class="loading-area" *ngIf="listData.dataSource.data.length === 0 || listData.loading">
  <mat-spinner *ngIf="listData.loading" [diameter]="50" strokeWidth="3"></mat-spinner>
  <app-no-data text="Keine Daten gefunden" *ngIf="listData.dataSource.data?.length === 0 && !listData.loading">
  </app-no-data>
</div>
<!-- template elektronische kommunikation -->
<ng-template #elektronischeko let-row="row" let-title="title" let-forwhom="forwhom"
             let-elektronischekommunikation="elektronischekommunikation">
  <div class="add-row">
    <span class="fixed-col gray-text">{{ title }}</span> <!-- TODO rename grey-text -->
    <span class="fixed-col">
        <div class="icon-text">
          <span class="check-msg">{{ getElekKomStatusText(row.data, forwhom) }}</span>
          <mat-icon
            [ngClass]="[getElekKomStatusClass(row.data, forwhom)]">{{ getElekKomStatusIcon(row.data, forwhom) }}</mat-icon>
        </div>
    </span>
    <div class="flex-container" *ngIf="bearbeitenErlaubt">
      <div class="button-col">
        <button mat-raised-button class="mat-gray-bg button-right-margin flex-button"
                (click)="openElekKomDialog(row.data, forwhom, true)">
          {{ getActivateLabel(row.data, forwhom) }}
        </button>
        <button mat-raised-button class="mat-gray-bg flex-button" (click)="openElekKomDialog(row.data, forwhom, false)"
                [disabled]="isDeactivateDisabled(row.data, forwhom)">
          {{ getDeactivateLabel(row.data, forwhom) }}
        </button>
      </div>
      <mat-icon class="info-icon"
                matTooltip="Mit Bestätigung des Verifizierungslinks zur Vereinbarung der elektronischen Kommunikation werden Polizzendokumente, Versicherungsbedingungen sowie Erklärungen und sonstige Informationen in Zusammenhang mit derzeit bei der NV AG bestehenden und zukünftig abgeschlossenen Versicherungsverträgen auf elektronischem Wege (per E-Mail) zugestellt. Wurde bei einer oder mehreren Polizze/n der E-Zahlschein vereinbart, so wird die im Rahmen der elektronischen Kommunikation vereinbarte E-Mail-Adresse zukünftig herangezogen."
                matTooltipPosition="right"
                matTooltipClass="tooltip-multiline">info_outline
      </mat-icon>
    </div>
  </div>
</ng-template>
<!-- /template elektronische kommunikation -->
